/**
 * 練習モード（一問練習）で選んだ面接官をブラウザに記憶する（#1863）。
 *
 * 一問練習はセッションを持たず、未ログインでも使えるため、選択の保存先をサーバに持てない。
 * ローカルストレージに識別子だけを保存し、次に練習画面を開いたときの既定にする。
 *
 * SSR（window 不在）・ローカルストレージ未対応・例外・不正値の場合は、すべて安全側
 * （既定の女性面接官）にフォールバックする。保存に失敗しても画面の動作は変えない。
 */
import { DEFAULT_INTERVIEWER_KEY, resolveInterviewer, type InterviewerKey } from "@/lib/interviewers";

export const PRACTICE_INTERVIEWER_STORAGE_KEY = "practiceInterviewerKey";

/** 記憶した面接官を返す。未保存・不正値・読み取り不可は既定の女性面接官 */
export function readPracticeInterviewerKey(): InterviewerKey {
  if (typeof window === "undefined") return DEFAULT_INTERVIEWER_KEY;
  try {
    return resolveInterviewer(localStorage.getItem(PRACTICE_INTERVIEWER_STORAGE_KEY)).key;
  } catch {
    return DEFAULT_INTERVIEWER_KEY;
  }
}

/** 選んだ面接官を記憶する。保存できなくても例外にしない */
export function savePracticeInterviewerKey(key: InterviewerKey): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(PRACTICE_INTERVIEWER_STORAGE_KEY, key);
  } catch {
    // 保存できない環境（プライベートモード等）では記憶しないだけで、練習は続けられる
  }
}
